module.exports = __webpack_public_path__ + "img/SCC_NK.b6d822ce.png";